import { FormValues } from './types';

export const FORM_FIELDS = {
  DESIGN_ID: {
    name: 'designId',
    label: 'Design',
  } as const,
  HEADLINE: {
    name: 'headline',
    label: 'Headline',
  } as const,
  RECIPIENT_NAME: {
    name: 'recipientName',
    label: 'Recipient Name',
  } as const,
  SENDER_NAME: {
    name: 'senderName',
    label: 'Sender Name',
  } as const,
};

export const DEFAULT_VALUES: FormValues = {
  designId: '',
  headline: '',
  recipientName: '',
  senderName: '',
};
